// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"b5-z"};